module.exports = __webpack_public_path__ + "static/media/reeltalk-logo.6f3bb57e.png";